import React, { useState } from "react";

import { format } from "date-fns";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../components/ui/form";
import { Input } from "../../components/ui/input";
import { useGetDepartments } from "../../hooks/useEmployee";

const countries = [
  { value: "Nigeria", label: "Nigeria" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Kenya", label: "Kenya" },
  { value: "Sierra Leone", label: "Sierra Leone" },
];

const contractType = [
  { value: "Contract", label: "Contract" },
  { value: "Internship", label: "Internship" },
  { value: "Fulltime", label: "Fulltime" },
];
export default function EditEmployee({
  form,
  setImage,
}: {
  form: any;
  setImage: any;
}) {
  const { department } = useGetDepartments();

  const [errorMessage, setErrorMessage] = useState("");

  const maxSizeLimits: { [key: string]: number } = {
    image: 5 * 1024 * 1024, // 5MB
  };

  const uploadImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      if (file) {
        const fileType = file.type;
        let typeCategory = "";

        if (fileType.startsWith("image/")) {
          typeCategory = "picture";
        }

        const maxSize = maxSizeLimits[typeCategory];

        if (file.size > maxSize) {
          setErrorMessage(
            `File size exceeds the maximum allowed size of ${
              maxSize / (1024 * 1024)
            }MB.`
          );
          return;
        } else {
          setErrorMessage("");
        }

        setImage(file);
      }
    }
  };

  return (
    <Form {...form}>
      <form className="grid sm:grid-cols-2 gap-3 w-full px-3">
        <FormField
          control={form.control}
          name="firstname"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="firstname" className="font-semibold ">
                First Name
              </FormLabel>
              <FormControl>
                <Input
                  id="firstname"
                  placeholder="Enter First Name"
                  {...field}
                />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="lastname"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="lastname" className="font-semibold ">
                Last Name
              </FormLabel>
              <FormControl>
                <Input id="lastname" placeholder="Enter Last Name" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="email" className="font-semibold ">
                Email
              </FormLabel>
              <FormControl>
                <Input id="email" placeholder="Enter Email" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="phone"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="phone" className="font-semibold ">
                Employee Phone
              </FormLabel>
              <FormControl>
                <Input id="email" placeholder="Enter Phone Number" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="department"
          render={({ field }) => (
            <FormItem className="flex flex-col items-start">
              <FormLabel className="font-semibold ">Department</FormLabel>
              <select
                {...field}
                id="department"
                className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"
              >
                {department?.map(
                  (option: {
                    id: React.Key | null | undefined;
                    title: string;
                  }) => (
                    <option key={option.id} value={option.title}>
                      {option.title}
                    </option>
                  )
                )}
              </select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="job_role"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="job_role" className="font-semibold ">
                Job role
              </FormLabel>
              <FormControl>
                <Input id="job_role" placeholder="" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="country"
          render={({ field }) => (
            <FormItem className="flex flex-col items-start">
              <FormLabel className="font-semibold ">Country</FormLabel>
              <select
                {...field}
                id="country"
                className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"
              >
                {countries?.map((option: { value: string; label: string }) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="city"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="city" className="font-semibold ">
                City
              </FormLabel>
              <FormControl>
                <Input id="city" placeholder="" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="employment_type"
          render={({ field }) => (
            <FormItem className="flex flex-col items-start">
              <FormLabel className="font-semibold ">
                Type of Employment
              </FormLabel>
              <select
                {...field}
                id="employment_type"
                className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"
              >
                {contractType?.map(
                  (option: { value: string; label: string }) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  )
                )}
              </select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="lead"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel htmlFor="lead" className="font-semibold ">
                Employee Lead
              </FormLabel>
              <FormControl>
                <Input id="lead" placeholder="" {...field} />
              </FormControl>
              <div className="flex items-center justify-end">
                <FormMessage />
              </div>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="datejoined"
          render={({ field }) => (
            <FormItem className="flex items-start flex-col">
              <FormLabel className="font-semibold ">Date Joined</FormLabel>
              <FormControl>
                <Input
                  type="date"
                  id="datejoined"
                  value={field.value ? format(field.value, "yyyy-MM-dd") : ""}
                  onChange={(e) => field.onChange(new Date(e.target.value))}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormItem className="flex items-start flex-col">
          <FormLabel htmlFor="image" className="font-semibold ">
            Upload Image (jpg, jpeg)
          </FormLabel>
          <FormControl>
            <Input
              type="file"
              id="sampleAsset"
              accept=".jpeg, .jpg"
              onChange={uploadImage}
            />
          </FormControl>
          {errorMessage && (
            <div className="text-red-500 mt-2">{errorMessage}</div>
          )}
          <div className="flex items-center justify-end">
            <FormMessage />
          </div>
        </FormItem>
      </form>
    </Form>
  );
}
